//local
// module.exports = {
//   API: 'http://localhost:3003',
//   FRONTEND_URL: 'localhost:3000',
//   recordTypes: {
//     SFMediaSubmissions: 'SFMediaSubmissions',
//     photos: 'photogs',
//     talents: 'talents',
//   },
// };

// dev;
// module.exports = {
//   API: 'https://irfaomrw31.execute-api.us-east-1.amazonaws.com/dev',
//   FRONTEND_URL: 'http://uat.talentuploader.s3-website-us-east-1.amazonaws.com',
//   recordTypes: {
//     SFMediaSubmissions: 'SFMediaSubmissions',
//     photos: 'photogs',
//     talents: 'talents',
//     tsubmissions: 'tsubmissions',
//   },
// };

//prod
module.exports = {
  API: 'https://r5w2jguwxa.execute-api.us-east-1.amazonaws.com/prod',
  FRONTEND_URL: 'https://talent-uploader.orionphotogroup.com',
  recordTypes: {
    SFMediaSubmissions: 'SFMediaSubmissions',
    photos: 'photogs',
    talents: 'talents',
    tsubmissions: 'tsubmissions',
  },
};
